
namespace Matrix.Rebalancer {

    @Serenity.Decorators.registerClass()
    export class PluginGrid extends SiteEntityGrid<PluginRow, any> {
        protected getColumnsKey() { return 'Rebalancer.Plugin'; }
        protected getDialogType() { return PluginDialog; }
        protected getIdProperty() { return PluginRow.idProperty; }
        protected getLocalTextPrefix() { return PluginRow.localTextPrefix; }
        protected getService() { return PluginService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}